import api from '@pray/shared/utils/api';

export async function uploadPrayTvContent({
  artistId,
  contentArtistId,
  title,
  primaryVideoUrl,
  primaryVideoFileDuration,
  primaryVideoFileSize,
  thumbnailUrl,
}: {
  artistId: string;
  contentArtistId?: string;
  title: string;
  primaryVideoUrl: string;
  primaryVideoFileDuration: number;
  primaryVideoFileSize: number;
  thumbnailUrl?: string;
}) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/pray-tv-content`;
  const data = {
    title,
    primary_video_url: primaryVideoUrl,
    primary_video_file_duration: primaryVideoFileDuration,
    primary_video_file_size: primaryVideoFileSize,
    ...(thumbnailUrl && { thumbnail_url: thumbnailUrl }),
    ...(contentArtistId && { artist_id: contentArtistId }),
  };

  const response = await api.executePostRequest(url, data);
  return response.data;
}
